'use client';

import Container from 'components/BlogContainer';
import BlogHeader from 'components/BlogHeader';
import Layout from 'components/BlogLayout';
import MoreStories from 'components/MoreStories';
import PostBody from 'components/PostBody';
import PostHeader from 'components/PostHeader';
import PostPageHead from 'components/PostPageHead';
import PostTitle from 'components/PostTitle';
import SectionSeparator from 'components/SectionSeparator';
import * as demo from 'lib/demo.data';
import type { Post, Settings } from 'lib/sanity.queries';
import Error from 'next/error';

export interface PostPageProps {
  preview?: boolean;
  loading?: boolean;
  post: Post | null;
  morePosts?: Post[];
  settings: Settings | null;
}

const NO_POSTS: Post[] = [];

export default function PostPage(props: PostPageProps) {
  const {
    preview = false,
    loading = false,
    morePosts = NO_POSTS,
    post,
    settings,
  } = props;

  const { title = demo.title } = settings || {};

  if (!post && !preview) {
    return <Error statusCode={404} />;
  }

  return (
    <>
      <PostPageHead settings={settings} post={post} />

      <Layout preview={preview} loading={loading}>
        <Container>
          <BlogHeader title={title} level={2} />
          {loading ? (
            <PostTitle>Loading…</PostTitle>
          ) : (
            <>
              <article>
                <PostHeader
                  title={post?.title}
                  coverImage={post?.coverImage}
                  date={post?.date}
                  author={post?.author}
                />
                <PostBody content={post?.content} />
              </article>
              <SectionSeparator />
              {morePosts?.length > 0 && <MoreStories posts={morePosts} />}
            </>
          )}
        </Container>
      </Layout>
    </>
  );
}